import React from 'react'

const MaterialSetTypeDesktopBackground = () => (
  <svg width="149" height="53" viewBox="0 0 149 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="51" cy="-45" r="98" fill="currentColor" />
  </svg>
)

export default MaterialSetTypeDesktopBackground
